import * as React from 'react';
import { useGetLogQuery } from "../../../apis/Log.api";
import { PrimaryLog, Log } from "../../../types/models/Log";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: Log;
};

export const LogNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.timberKey }
                    {data?.externalKey && <> | </> }{ data?.externalKey }
                    {data?.internalKey && <> | </> }{ data?.internalKey }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const LogName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetLogQuery(PrimaryLog.fromId(id))
    return (<LogNameDisplay data={data}/>)
}

export default LogName;
